import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ISPUITooltipModule } from '@ispui/ng-tooltip';

import { FormIdPrefixModule } from 'common/form-id-prefix/form-id-prefix.module';
import { SvgIconModule } from 'common/svg-icon/svg-icon/svg-icon.module';

import { FieldHintComponent } from './hint.component';

@NgModule({
  declarations: [FieldHintComponent],
  exports: [FieldHintComponent],
  imports: [
    CommonModule,
    SvgIconModule,
    ISPUITooltipModule,
    FormIdPrefixModule,
  ],
})
export class FieldHintModule {}
